export const malgorzataRzymyszkiewicz = {
    'firstName': 'Małgorzata',
    'lastName': 'Rzymyszkiewicz',
    'mydrId': 'małgorzatarzymyszkiewicz',
    'profession': 'Psycholog, psychoterapeuta psychodynamiczny',
    'avatar': 'malgorzata-rzymyszkiewicz.webp',
    'slug': 'psycholog-psychoterapeuta-malgorzata-rzymyszkiewicz',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'adult'],
    ]
}